import { NavLink } from 'react-router';

const DEV_ROUTES = {
  authentication: '/dev/authentication',
  agencyConfig: '/dev/agency-config',
  portalHub: '/dev/portal-hub',
} as const;

export function DevNavTabs() {
  return (
    <div className="nav nav-underline mb-4">
      <li className="nav-item">
        <NavLink to={DEV_ROUTES.authentication} className="nav-link">
          Authentication
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink to={DEV_ROUTES.agencyConfig} className="nav-link">
          AgencyConfig
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink to={DEV_ROUTES.portalHub} className="nav-link">
          Portal hub
        </NavLink>
      </li>
    </div>
  );
}
